import React, { useState } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button } from '../controls';
import { useFestivalWorkspaceStore } from '@/stores/festival-workspace-store';
import {
  useAssociateSponsorMutation,
  useDisassociateSponsorMutation,
  useSponsorsForObjectQuery,
  useSponsorsQuery,
} from '@/queries/sponsors';

export function AssignedSponsors({ objectType, objectId }) {
  const festival = useFestivalWorkspaceStore((s) => s.festival);
  const festivalId = festival?.festivalId;

  const sponsorsQ = useSponsorsQuery(festivalId);
  const objectSponsorsQ = useSponsorsForObjectQuery(
    festivalId,
    objectType,
    objectId,
  );
  const associateMutation = useAssociateSponsorMutation(
    festivalId,
    objectType,
    objectId,
  );
  const disassociateMutation = useDisassociateSponsorMutation(
    festivalId,
    objectType,
    objectId,
  );

  const sponsors = sponsorsQ.data ?? [];
  const objectSponsors = objectSponsorsQ.data ?? [];
  const loading =
    sponsorsQ.isPending ||
    sponsorsQ.isFetching ||
    objectSponsorsQ.isPending ||
    objectSponsorsQ.isFetching;

  const [selectKey, setSelectKey] = useState(0);

  const handlePick = (e) => {
    const raw = e.target.value;
    if (!raw) {
      return;
    }
    const sponsorId = Number(raw);
    associateMutation.mutateAsync({ sponsorId }).catch(() => {});
    setSelectKey((k) => k + 1);
  };

  const handleRowRemove = (sponsorId) => {
    disassociateMutation.mutateAsync(sponsorId).catch(() => {});
  };

  let filteredSponsors = sponsors || [];

  if (sponsors && objectSponsors) {
    filteredSponsors = sponsors.filter(
      (s) => objectSponsors.find((sp) => sp.sponsorId === s.sponsorId) == null,
    );
  }

  return (
    <div className="p-6">
      <div className="my-4 w-full text-center">
        <select
          key={selectKey}
          className="h-10 w-3/4 rounded-[20px] border border-[var(--festy-input-border)] px-4 outline-none"
          disabled={loading || filteredSponsors.length === 0}
          defaultValue=""
          onChange={handlePick}
          aria-label="Add sponsor"
        >
          <option value="">
            {filteredSponsors.length === 0
              ? 'No sponsors left'
              : 'Select sponsors'}
          </option>
          {filteredSponsors.map((sponsor) => (
            <option key={sponsor.sponsorId} value={String(sponsor.sponsorId)}>
              {sponsor.sponsorName}
            </option>
          ))}
        </select>
      </div>
      {loading ? (
        <p className="py-8 text-center text-[var(--festy-muted-text)]">
          Loading…
        </p>
      ) : (
        <ul className="m-0 list-none divide-y divide-[var(--festy-light-gray)] p-0">
          {(objectSponsors || []).map((item) => (
            <li
              key={item.sponsorId}
              className="flex items-start gap-4 py-4 first:pt-0"
            >
              <img
                src={item.photoURL}
                alt=""
                className="h-12 w-12 shrink-0 rounded-full bg-[var(--festy-light-gray)] object-cover"
              />
              <div className="min-w-0 flex-1 text-left">
                <div className="font-medium text-[var(--foreground)]">
                  {item.sponsorName}
                </div>
                <div className="mt-1 text-sm text-[var(--festy-muted-text)]">
                  {item.sponsorDescription &&
                  item.sponsorDescription.length > 200
                    ? `${item.sponsorDescription.slice(0, 200)}…`
                    : (item.sponsorDescription ?? '')}
                </div>
              </div>
              <Button onClick={() => handleRowRemove(item.sponsorId)}>
                <FontAwesomeIcon icon={['far', 'trash']} />
              </Button>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
